import { Link } from 'react-router'
import { OperatingField } from '@/components/visuals/OperatingField'
import { MotionVideo } from '@/components/MotionVideo'
import { PrimaryCta, Reveal } from '@/components/primitives'

const CHIPS = [
  '145M+ policies processed',
  'Records + routing + conversations',
  'Workflows with control',
  'Nex inside your rules',
]

export function Hero() {
  return (
    <section
      aria-labelledby="hero-title"
      className="relative overflow-hidden border-b border-base-line"
    >
      <MotionVideo
        src="/videos/hero-field-web.mp4"
        poster="/videos/hero-field-poster.jpg"
        eager
        className="pointer-events-none absolute inset-0 opacity-40"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 bg-gradient-to-b from-base-950/80 via-base-950/55 to-base-950/90"
      />
      <div className="relative mx-auto w-full max-w-[90rem] px-5 pb-14 pt-14 sm:px-8 md:pb-16 md:pt-20">
        <Reveal>
          <div className="mx-auto max-w-3xl text-center">
            <p className="eyebrow">Customer Operations Platform</p>
            <h1
              id="hero-title"
              className="mt-5 text-4xl font-extrabold leading-[1.05] tracking-tight text-ink sm:text-5xl xl:text-[3.25rem]"
            >
              Make the whole operation <span className="text-signal">visible.</span>
            </h1>
            <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-ink-mute md:text-lg">
              One system for every record, call, queue, workflow, and outcome. Your team stops
              guessing. Work stops falling through the cracks.
            </p>
            <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
              <PrimaryCta to="/walkthrough">Book a walkthrough</PrimaryCta>
              <Link to="/platform" className="btn-ghost px-0">
                Explore the platform →
              </Link>
            </div>
            <ul
              aria-label="Why teams choose TLDNXS"
              className="mt-8 flex flex-wrap items-center justify-center gap-2"
            >
              {CHIPS.map((chip) => (
                <li key={chip} className="chip-neutral">
                  {chip}
                </li>
              ))}
            </ul>
          </div>
        </Reveal>

        <Reveal delay={120}>
          <div className="mx-auto mt-12 max-w-6xl">
            <OperatingField />
          </div>
        </Reveal>
      </div>
    </section>
  )
}
